// extracted by mini-css-extract-plugin
export var separator = "Separator-module--separator--Aq2Mw";
export var left = "Separator-module--left--FttKy";
export var md = "Separator-module--md--MO58Y";
export var lg = "Separator-module--lg--V+024";